const CANONICAL_AI_LICENSE = "ai_users_license";

export const normalizeLicenseType = (type?: string) =>
  (type ?? "")
    .toLowerCase()
    .replace(/[\s-]+/g, "_")
    .trim();

export const isAiUsersLicense = (type?: string) => {
  const normalized = normalizeLicenseType(type);
  if (!normalized) {
    return false;
  }

  if (normalized === CANONICAL_AI_LICENSE) {
    return true;
  }

  return normalized.replace(/_/g, "") === CANONICAL_AI_LICENSE.replace(/_/g, "");
};
